import { render, staticRenderFns } from "./IFTC.vue?vue&type=template&id=05332874&scoped=true&"
import script from "./IFTC.vue?vue&type=script&lang=js&"
export * from "./IFTC.vue?vue&type=script&lang=js&"
import style0 from "./IFTC.vue?vue&type=style&index=0&id=05332874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05332874",
  null
  
)

export default component.exports